/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reason_For_Release_PlaceholderInputs */

const en_reason_for_release_placeholder = /** @type {(inputs: Reason_For_Release_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Customer confirmed order, releasing hold`)
};

const es_reason_for_release_placeholder = /** @type {(inputs: Reason_For_Release_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. El cliente confirmo el pedido, liberando apartado`)
};

/**
* | output |
* | --- |
* | "e.g., Customer confirmed order, releasing hold" |
*
* @param {Reason_For_Release_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reason_for_release_placeholder = /** @type {((inputs?: Reason_For_Release_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reason_For_Release_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reason_for_release_placeholder(inputs)
	return es_reason_for_release_placeholder(inputs)
});